module.exports = __webpack_public_path__ + "img/pic-5.9bb72198.png";